/* Recipe V2 Client barrel export */

import { RecipeV2ClientApi } from './recipeV2ClientApi';
import { RecipeV2ClientMocked } from './recipeV2ClientMocked';

// Re-export types
export * from './recipeV2Types';
export * from './recipeComplianceMatrixTypes';

// Recipe V2 has a real backend for basic CRUD (Slice 1) - unfinished features still fall
// back to mocked behaviour inside RecipeV2ClientApi.
const recipeV2Client = new RecipeV2ClientApi();
const demoRecipeV2Client = new RecipeV2ClientMocked();

export { recipeV2Client, demoRecipeV2Client, RecipeV2ClientMocked };
export type { IRecipeV2Client } from './IRecipeV2Client';
